import script from "./DesktopOnlyNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopOnlyNotice.vue?vue&type=script&setup=true&lang=js"

import "./DesktopOnlyNotice.vue?vue&type=style&index=0&id=df887d92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df887d92"]])

export default __exports__